<template>
	<v-dialog v-model="visible" persistent max-width="600px">
		<v-card>
			<v-card-title>
				<v-icon style="margin-right: 10px"> {{ 'mdi-menu-edit' }} </v-icon>
				{{ title }}
			</v-card-title>
			<v-card-text>
				<v-data-table
					:headers="headers"
					:items="items"
					item-value="code"
					show-select
					v-model="selectedItems"
					:items-per-page="-1"
					hide-default-footer
					fixed-header
				>
				</v-data-table>
			</v-card-text>
			<v-card-actions class="d-flex justify-right">
				<v-btn rounded :color="$theme.lightGrey" dark elevation="0" @click="$emit('onCancel')">닫기</v-btn>
				<v-btn rounded :color="$theme.primary" dark elevation="0" @click="onOk">저장</v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>
	export default {
		name: 'MenuClassSelectDialog',
		props: {
			show: {
				type: Boolean,
				default: false,
			},
			items: {
				type: Array,
				default: () => [],
			},
			title: {
				type: String,
				default: '',
			},
			level: {
				type: Number,
				default: 1,
			},
		},
		data() {
			return {
				visible: this.show,
				selectedItems: [], // 선택된 항목을 저장하는 배열
			};
		},
		watch: {
			show(val) {
				this.visible = val;
			},
		},
		mounted() {
			document.addEventListener('keydown', this.handleKeydown);
		},
		beforeDestroy() {
			document.removeEventListener('keydown', this.handleKeydown);
		},
		methods: {
			handleKeydown(event) {
				if (event.key === 'Escape' || event.key === 'Esc' || event.keyCode === 27) {
					this.$emit('onCancel');
				}
			},
			onOk() {
				// 저장 후 선택된 항목 초기화 (체크 해제)
				this.$emit('onOk', this.selectedItems);
				this.selectedItems = []; // 모든 선택 해제
			},
		},
		computed: {
			headers() {
				return [
					{ text: '메뉴코드', value: 'code', align: 'center', sortable: false },
					{ text: '메뉴명', value: 'title', align: 'center', sortable: false },
				];
			},
		},
	};
</script>
